var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlexibleWorkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 2,
    fill: "#D75F04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3153 44.9474V39.4737H54.2102V44.9474H65.3153ZM37.5525 53.1579V77.7895C37.5525 79.2947 38.8019 80.5263 40.3288 80.5263H79.1966C80.7236 80.5263 81.9729 79.2947 81.9729 77.7895V53.1579C81.9729 51.6526 80.7236 50.4211 79.1966 50.4211H40.3288C38.8019 50.4211 37.5525 51.6526 37.5525 53.1579ZM81.9729 44.9474C85.0546 44.9474 87.5254 47.3832 87.5254 50.4211V80.5263C87.5254 83.5642 85.0546 86 81.9729 86H37.5525C34.4709 86 32 83.5642 32 80.5263L32.0278 50.4211C32.0278 47.3832 34.4709 44.9474 37.5525 44.9474H48.6576V39.4737C48.6576 36.4358 51.1285 34 54.2102 34H65.3153C68.3969 34 70.8678 36.4358 70.8678 39.4737V44.9474H81.9729Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexibleWorkIcon);
export default __webpack_public_path__ + "static/media/flexible-work-icon.7f658fde9c7f6a5da3c80be5a0b8e275.svg";
export { ForwardRef as ReactComponent };